import api from '@/api/learners';

const actions = {
  FETCH_LEARNERS: async ({ commit, dispatch, state, rootGetters }) => {
    dispatch('wait/start', 'learners fetching', { root: true });

    try {
      const { results: learners } = await api.fetchLearners({
        organizationId: rootGetters.organizationId,
        pageSize: state.pageSize,
        currentPage: state.currentPage,
        ordering: state.ordering,
        search: state.learnersFilters.query,
        dateRange: state.dateRange,
        filters: JSON.parse(JSON.stringify(state.filters)),
      });

      commit('SET_LEARNERS', { learners });

      dispatch('wait/end', 'learners fetching', { root: true });
    } catch (error) {
      if (error.name !== 'AbortError') throw error;
    }
  },

  DOWNLOAD_LEARNERS: ({ state, rootGetters }, { formatType, callback }) => {
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    return new Promise(resolve => {
      api
        .fetchLearners({
          organizationId: rootGetters.organizationId,
          pageSize: state.count,
          currentPage: state.currentPage,
          ordering: state.ordering,
          search: state.learnersFilters.query,
          dateRange: state.dateRange,
          format: formatType,
          include: fields,
          filters: JSON.parse(JSON.stringify(state.filters)),
          callback: response => {
            return response.blob();
          },
        })
        .then(callback)
        .then(resolve);
    });
  },

  UPLOAD_LEARNERS: ({ rootGetters }, { file }) => {
    return new Promise((resolve, reject) => {
      api
        .uploadLearners({
          file,
          organizationId: rootGetters.organizationId,
        })
        .then(resolve, reject);
    });
  },

  UPLOAD_SCHEDULED_LEARNERS: async ({ rootGetters }, { file, activationDateTime }) => {
    await api.uploadScheduledLearners({
      file,
      organizationId: rootGetters.organizationId,
      activationDateTime,
    });
  },

  BATCH_UPDATE_LEARNERS: ({ rootGetters }, { file }) => {
    const { organizationId } = rootGetters;

    return api.batchUpdateLearners({ file, organizationId });
  },

  PRIVATE_CLASSES_CREDIT_UPDATE_BATCH: async ({ rootGetters }, { file }) => {
    const { organizationId } = rootGetters;
    return api.privateClassesCreditsUpdateBatch({ file, organizationId });
  },

  PRIVATE_CLASS_HOURS_ALLOCATE_BATCH: async ({ rootGetters }, { file }) => {
    const { organizationId } = rootGetters;
    return api.privateClassHoursAllocateBatch({ file, organizationId });
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', { currentPage: 0 });
    dispatch('FETCH_LEARNERS');
  },

  SAVE_LEARNER: async ({ commit }, { learnerObject }) => {
    const profile = await api.saveLearner(learnerObject);
    commit('learner/SET_PROFILE', profile);

    return profile;
  },
};

export default actions;
